export default [
  {
    value: 'form-1583',
    name: 'USPS 1583 form required',
    text: 'Please note: Before we can release the mail to you, we will need you to fill out USPS Form 1583. They will have to be notarized if you are unable to come by and fill them out in front of us!'
  },
  {
    value: 'form-1583-and-17538',
    name: 'USPS 1583 form and 17538 are required',
    text: 'Please note: Before we can release the mail to you, we will need you to fill out USPS Form 1583 and form 17538. They will have to be notarized if you are unable to come by and fill them out in front of us!'
  },
  {
    value: 'partial-scan',
    name: 'Partial scan',
    text: 'Please note: This mail item was partially scanned.'
  },
  {
    value: 'package-pick-up',
    name: 'Package pick up',
    text: 'Please note: This package weighs more than 5lbs. Please make sure to pick it up within one business day otherwise a storage fee may apply.'
  },
  {
    value: 'heavy-package',
    name: 'Heavy package',
    text: 'Please note: The package is heavy, and you may want to consider bringing help when you retrieve it.'
  },
  {
    value: 'custom',
    name: 'Custom...',
    text: ''
  }
]